"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ErrorRender = require("./ErrorRender/ErrorRender");

var _key = require("./key");

var _Spinner = require("./Spinner/Spinner");

require("./styles.css");

var _excluded = ["animated", "reloadIconColor", "reloadIcon", "spinnerIcon", "spinnerColor", "hideSpinner", "onError", "onLoad", "url", "width", "height", "acEnv", "alt", "headers"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var baseServiceUrl = "https://service.assetcrush.com";

var ImageCrush = function ImageCrush(_ref) {
  var _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? true : _ref$animated,
      reloadIconColor = _ref.reloadIconColor,
      reloadIcon = _ref.reloadIcon,
      spinnerIcon = _ref.spinnerIcon,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === void 0 ? "#fff" : _ref$spinnerColor,
      _ref$hideSpinner = _ref.hideSpinner,
      hideSpinner = _ref$hideSpinner === void 0 ? false : _ref$hideSpinner,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {
    return null;
  } : _ref$onError,
      _ref$onLoad = _ref.onLoad,
      onLoad = _ref$onLoad === void 0 ? function () {
    return null;
  } : _ref$onLoad,
      url = _ref.url,
      width = _ref.width,
      height = _ref.height,
      _ref$acEnv = _ref.acEnv,
      acEnv = _ref$acEnv === void 0 ? "production" : _ref$acEnv,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];

  var handleError = (0, _react.useCallback)(function (e) {
    onError(e);
    setIsError(true);
  }, [onError, setIsError]);
  var fetchImage = (0, _react.useCallback)(function () {
    setIsError(false);

    var _width = width || "auto";

    var _height = height || "auto";

    var imageUrl = "".concat(baseServiceUrl, "?width=").concat(_width, "&height=").concat(_height, "&original_uri=").concat(encodeURIComponent(url));
    var key = (0, _key.getKey)() ? (0, _key.getKey)() : process.env.NODE_ENV === "development" ? 'test-key' : '';
    var headers = {};

    if (process.env.NODE_ENV === "development" && !(0, _key.getKey)()) {
      console.log(' Key is not present, please go to console.assetcrush.com and sign up to get one.');
    }

    fetch(imageUrl, {
      headers: _objectSpread({
        "assetcrush-key": key,
        "ac-env": acEnv
      }, headers)
    }).then(function (r) {
      headers = r.headers;
      return r.blob();
    }).then(function (d) {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) return;

      if (!d.type.includes("image")) {
        throw new Error("Object is not a valid image");
      }

      setImage(window.URL.createObjectURL(d));
      return Promise.resolve();
    }).then(function () {
      return onLoad(headers);
    })["catch"](handleError);
  }, [acEnv, handleError, height, onLoad, url, width, setIsError, setImage]);
  var handleRetry = (0, _react.useCallback)(function () {
    fetchImage();
  }, [fetchImage]);
  (0, _react.useEffect)(function () {
    if (!url) return;
    fetchImage(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, width, height]);

  if (isError) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorRender.ErrorRender, {
      width: width,
      height: height,
      reloadIconColor: reloadIconColor,
      icon: reloadIcon,
      handleRetry: handleRetry
    });
  }

  if (!image) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideSpinner && /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, {
      width: width,
      height: height,
      icon: spinnerIcon,
      color: spinnerColor
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("img", _extends({
    className: animated && "assetcrush-fade-in-Image",
    src: image,
    alt: alt
  }, props));
};

var _default = /*#__PURE__*/_react["default"].memo(ImageCrush);

exports["default"] = _default;